// src/component/admin/future-gifts/OverviewTab.jsx
import React, { useState } from 'react';
import { CheckCircleIcon, CalendarIcon, CautionIcon, ClockIcon, ProductCatalogIcon, ArrowDown, SearchIcon } from '../../../public/icons';
import Pagination from '../../shared/Pagination';

const OverviewTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const stats = [
    { label: 'Total Orders', value: '25', icon: <ProductCatalogIcon />, color: 'bg-blue-50 text-blue-600' },
    { label: 'Scheduled Future Gifts', value: '30', icon: <CalendarIcon />, color: 'bg-purple-50 text-purple-600' },
    { label: 'Waiting Content Upload', value: '8', icon: <CautionIcon />, color: 'bg-yellow-50 text-yellow-600' },
    { label: 'Ready for Fulfilment', value: '8', icon: <CheckCircleIcon />, color: 'bg-green-50 text-green-600' }
  ];

  const recentActivities = [
    { id: 1, customer: 'Adebayo Johnson', giftType: 'Memory Magnet Set', action: 'Uploaded content', time: '2 Hours ago', status: 'Ready' },
    { id: 2, customer: 'Chiamaka Chukwuka', giftType: 'Audio Gift', action: 'Scheduled', time: '5 Hours ago', status: 'In production' },
    { id: 3, customer: 'Emeka Nwachukwu', giftType: 'Digital Memory', action: 'Awaiting Content', time: '1 day ago', status: 'Waiting' },
    { id: 4, customer: 'Ngozi Adewale', giftType: 'Memory Magnet Set', action: 'Uploaded content', time: '5 days ago', status: 'Ready' },
    { id: 5, customer: 'Esther James', giftType: 'Memory Magnet Set', action: 'Scheduled', time: '10 days ago', status: 'In production' }
  ];

  const statusFilters = [
    { id: 'all', label: 'All Status' },
    { id: 'ready', label: 'Ready' },
    { id: 'in-production', label: 'In production' },
    { id: 'waiting', label: 'Waiting' }
  ];

  const getStatusBadge = (status) => {
    const statusConfig = {
      'Ready': {
        textColor: 'text-[#2F8F5B]',
        bgColor: 'bg-[#E7F4ED]',
        dotColor: 'bg-[#2F8F5B]'
      },
      'In production': {
        textColor: 'text-[#194F9B]',
        bgColor: 'bg-[#EBEFFF]',
        dotColor: 'bg-[#194F9B]'
      },
      'Waiting': {
        textColor: 'text-[#D8A100]',
        bgColor: 'bg-[#FFF4D6]',
        dotColor: 'bg-[#D8A100]'
      }
    };

    const config = statusConfig[status] || statusConfig.Waiting;

    return (
      <span className={`flex items-center gap-1.5 px-3 py-1.5 text-xs leading-5 font-semibold rounded-full ${config.bgColor} w-fit`}>
        <span className={`h-2 w-2 rounded-full ${config.dotColor}`} />
        <span className={config.textColor}>
          {status}
        </span>
        <ArrowDown size={12} className={config.textColor} />
      </span>
    );
  };

  const handleMenuAction = (id) => {
    console.log('Menu action for gift activity:', id);
    // Handle menu action here
  };

  // Filter activities based on search and status
  const filteredActivities = recentActivities.filter(activity => {
    const matchesSearch = activity.customer.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         activity.giftType.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || 
                         activity.status.toLowerCase().includes(statusFilter.toLowerCase());
    return matchesSearch && matchesStatus;
  });

  return (
    <div className="p-6">
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white rounded-sm p-5">
            <div className="text-left">
              <div className={`flex justify-center items-center rounded-md h-12 w-12 ${stat.color}`}>
                {stat.icon}
              </div>
              <div>
                <p className="text-3xl font-bold text-[#1C2A46] mt-4">{stat.value}</p>
                <p className="text-sm text-[#6B635D] mt-1">{stat.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

     <div className=' bg-white'>
         {/* Recent Future Gift Activity - Header */}
      <div className="mb-6 p-3">
        <div className="flex items-center justify-between">
                 <h2 className="text-xl font-medium text-[#0E1628]">Recent Future Gift Activity</h2>
                 
                 <div className="flex gap-4 items-center">
                   {/* Search Box */}
                   <div className="relative">
                     <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                       <SearchIcon size={20} className="text-[#6B635D]" />
                     </div>
                     <input
                       type="text"
                       placeholder="Search"
                       value={searchQuery}
                       onChange={(e) => setSearchQuery(e.target.value)}
                       className="p-2 pl-10 pr-3 border w-52 border-[#DBDBDB] bg-transparent placeholder:text-[#6B635D] placeholder:text-sm focus:outline-none focus:ring-1 focus:ring-[#D4A574] focus:border-transparent"
                     />
                   </div>
       
                   {/* Status Filter */}
                   <div className="relative">
                     <select
                       value={statusFilter}
                       onChange={(e) => setStatusFilter(e.target.value)}
                       className="p-2 pl-3 pr-8 border w-40 border-[#DBDBDB] bg-transparent text-[#1C2A46] text-sm appearance-none focus:outline-none focus:ring-1 focus:ring-[#D4A574] focus:border-transparent"
                     >
                       {statusFilters.map(filter => (
                         <option key={filter.id} value={filter.id}>
                           {filter.label}
                         </option>
                       ))}
                     </select>
                     <div className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
                       <ArrowDown size={16} className="text-[#6B635D]" />
                     </div>
                   </div>
       
                 </div>
               </div>
      </div>

      {/* Table with white background */}
      <div className="bg-white overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-[#DBDBDB]">
            <thead className="bg-[#F3F4F6]">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                  Customer
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                  Gift Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                  Action
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider">
                  Time
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider w-fit">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-normal text-[#6B635D] uppercase tracking-wider w-20">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-[#DBDBDB] text-left">
              {filteredActivities.map((activity) => (
                <tr key={activity.id} className="hover:bg-gray-50 transition-colors duration-150">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-normal text-[#0E1628]">{activity.customer}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-normal text-[#0E1628]">{activity.giftType}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-normal text-[#8A9099]">{activity.action}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="text-sm font-normal text-[#8A9099]">{activity.time}</span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap w-fit">
                    {getStatusBadge(activity.status)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap w-20">
                    <button
                      onClick={() => handleMenuAction(activity.id)}
                      className="text-[#6B635D] hover:text-[#1C2A46] transition-colors mx-auto block"
                    >
                      <span className="text-lg font-bold">⋮</span>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

       <Pagination totalItems={filteredActivities.length} itemsPerPage={5} />
      </div>
     </div>
    </div>
  );
};

export default OverviewTab;